import { WerklijstEntry } from "../../types/werklijst";
import { API_URL } from "./config";

/**
 * Fetch werklijsten for the authenticated user within a date range
 */
export async function fetchWerklijsten(
  startDate?: string,
  endDate?: string
): Promise<WerklijstEntry[]> {
  const token = localStorage.getItem("token");
  
  if (!token) {
    throw new Error("Authentication token is required");
  }
  
  const params = new URLSearchParams();
  
  if (startDate) {
    params.append("startDate", startDate);
  }
  
  if (endDate) {
    params.append("endDate", endDate);
  }

  const queryString = params.toString();
  const url = queryString ? `${API_URL}/werklijsten?${queryString}` : `${API_URL}/werklijsten`;
  
  const response = await fetch(url, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
  
  if (!response.ok) {
    const error = await response
      .json()
      .catch(() => ({ message: "Failed to fetch werklijsten" }));
    throw new Error(error.message);
  }
  
  const data = await response.json();
  
  return data;
}
